import { InjectionToken } from '@angular/core';
import { DomainConfig } from '../models/domain-config.interface';

export const DOMAIN_CONFIG = new InjectionToken<DomainConfig>('Client Config');
